import React, {useCallback, useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {
  loadCampaigns,
  loadCarousel,
  loadPromotionalEvents,
  loadWeeklyBrands
} from "../../../../redux/slices/dynamicElementsSlice";
import CustomCarousel from "./CustomCarousel";
import {BANNER_TYPE} from "../../../../constants/commons";

const CustomBanner = ({bannerType = BANNER_TYPE.top, marginClass = "mt-2", mobile, showArrowButton = false, showDotIndicator=false, section}) => {

  const bannerInfoList = useSelector((state) => state.dynamicElements[bannerType]);
  const dispatch = useDispatch();
  useEffect(() => {
    if (!bannerInfoList?.init && !bannerInfoList?.loading && !bannerInfoList?.error) {
      fetchCarouselData();
    }
  }, [dispatch, bannerInfoList.init, bannerInfoList.loading, bannerInfoList?.error]);

  const fetchCarouselData = useCallback(() => {
    if (bannerType === BANNER_TYPE.brand_week) {
      dispatch(loadWeeklyBrands());
    } else if (bannerType === BANNER_TYPE.campaigns) {
      dispatch(loadCampaigns());
    } else if (bannerType === BANNER_TYPE.promotional_events) {
      dispatch(loadPromotionalEvents());
    } else {
      dispatch(loadCarousel());
    }
  }, [bannerType, dispatch, section?.value]);

  return (
    <CustomCarousel retry={fetchCarouselData} bannerList={bannerInfoList} type={bannerType} mobile={mobile}
                      showArrowButton={showArrowButton} showDotIndicator={showDotIndicator} className={`w-full ${bannerType === BANNER_TYPE.top && !mobile ? "mt-4" : "mt-2"}`}/>
  );
};

export default React.memo(CustomBanner);